<template>
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="80" height="80" rx="40" :fill="bgFill" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.8426 20.7305C45.4004 21.0415 45.6742 21.6929 45.5062 22.3091L41.818 35.8325H55.2774C55.8304 35.8325 56.3308 36.1606 56.5512 36.6679C56.7716 37.1751 56.6701 37.7648 56.2927 38.1691L36.8483 59.0024C36.4125 59.4693 35.7144 59.5788 35.1566 59.2678C34.5988 58.9568 34.3249 58.3055 34.493 57.6893L38.1812 44.1658H24.7218C24.1688 44.1658 23.6684 43.8377 23.448 43.3305C23.2276 42.8233 23.3291 42.2336 23.7065 41.8293L43.1509 20.996C43.5867 20.529 44.2847 20.4195 44.8426 20.7305Z"
      fill="#0D0E0F"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps({
  bgFill: {
    type: String,
    default: 'var(--color-accent-primary)'
  }
})
</script>
